import { mapState } from 'vuex';
import Contextmenu from '../../chart/Contextmenu.vue';

export default {
  components: {
    Contextmenu,
  },
  data() {
    return {
      contextmenuParam: {
        show: false,
        x: 0,
        y: 0,
        items: [],
      },
    };
  },
  computed: {
    ...mapState('common/menu', ['realtime']),
    ...mapState('common/system', ['system']),
    menus() {
      const [{ children: realtimeMenus }] = this.realtime;
      const [{ children: menus }] = realtimeMenus.filter(m => m.name == this.system.stackType.toLowerCase());
      return menus;
    },
  },
  methods: {
    onContextmenuChart(event) {
      event.preventDefault();
      const menu = this.menus.find(menu => menu.url == this.contextmenuUrl);
      if (!menu) return;
      this.contextmenuParam = {
        show: true,
        x: event.clientX,
        y: event.clientY,
        items: [
          {
            icon: menu.icon,
            text: this.$t(menu.messageCode),
            handler: () => window.open(`${menu.url}/${this.system.id}`, '_blank'),
          },
        ],
      };
    },
  },
};
